import AppLoader from '@/components/AppLoader';
import Header from '@/components/header';
import { AuthProvider } from '@/context/AuthContextProvider';
import { SearchWidgetProvider } from '@/context/SearchWidgetContextProvider';
import { BookingExpiryProvider } from '@/contexts/BookingExpiryContext';
import { cn } from '@/utils/cn';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

function App() {
  const location = useLocation();

  return (
    <AppLoader>
      <AuthProvider>
        <SearchWidgetProvider>
          <BookingExpiryProvider>
            <div className="flex min-h-screen min-w-mobile flex-col">
              <ToastContainer
                position="top-center"
                theme="colored"
                pauseOnFocusLoss={false}
                pauseOnHover={false}
                hideProgressBar
              />
              <Header />
              <main className="flex w-full flex-1">
                <div
                  className={cn('w-full', {
                    'flex flex-1': location.pathname.startsWith('/account'),
                  })}
                >
                  <Outlet />
                </div>
              </main>
            </div>
          </BookingExpiryProvider>
        </SearchWidgetProvider>
      </AuthProvider>
    </AppLoader>
  );
}

export default App;
